<template>
	<div class="arrangement-fee">
		<b-form role="form" class="mt-4">
			<b-row>
				<b-col md="8" cols="12">
					<b-form-group label="Arrangement Fee (%)" v-if="form.calculation_type == 'auto'">
						<el-radio-group v-model="arg_fee" fill="#13663E">
							<el-radio-button v-for="(prc,index) in arg_fee_opt" :key="index" :label="prc" :class="(prc == arg_fee ? 'is-active':'')" :disabled="is_readonly">
								<template #default>{{ parseInt(prc)}}%</template>
							</el-radio-button>
							<el-radio-button label="Specify" :disabled="is_readonly"></el-radio-button>
						</el-radio-group>
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12" v-if="arg_fee == 'Specify' && form.calculation_type == 'auto'" >
					<b-form-group label="Specify Arrangement Fee (%)">
						<b-form-input v-model="form.arrangement_fee_prc" type="text" maxlength="2" :disabled="is_readonly"
							@keydown="preventNonNumericInput">
						</b-form-input>
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12">
					<b-form-group label="Arrangement Fee Amount (RM)">
						<CurrencyInput v-model="form.arrangement_fee_amt"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" 
							:disabled="is_readonly"
							/>
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12"  v-if="form.calculation_type == 'auto'">
					<b-form-group label="Arrangement Fee SST">
						<b-form-radio-group v-model="form.arrangement_sst_prc">
							<b-form-radio value="0.00" :disabled="is_readonly">0%</b-form-radio>
							<b-form-radio value="6.00" :disabled="is_readonly">6%</b-form-radio>
						</b-form-radio-group>
					</b-form-group>
				</b-col>
				<b-col cols="8" v-if="!is_readonly">
					<el-button class="bg-primary text-white w-50" @click.prevent="updateAll()"
						:loading="is_loading">Save</el-button>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>
<script>
import { Button, RadioButton, RadioGroup } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { preventNonNumericInput } from '@/assets/js/formValidations.js'
import { mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'

export default {
	props: ['activeCase','is_readonly'],
	components: {
		CurrencyInput,
		[Button.name]: Button,
		[RadioButton.name]: RadioButton,
		[RadioGroup.name]: RadioGroup,
	},
	data() {
		return {
			arg_fee: '',
			arg_fee_opt: ['0.00', '5.00', '7.00'],
			form: {
				calculation_type: '',
				arrangement_fee_prc: '',
				arrangement_fee_amt: '',
				arrangement_sst_prc: ''
			},
			is_loading: false,
		}
	},
	watch: {
		'activeCase': {
			handler(newValue, oldValue) {
				this.setForm(newValue)
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useLoanCaseStore, ['updateCase']),
		preventNonNumericInput,
		setForm(data) {
			this.form.calculation_type = data.calculation_type;
			this.form.arrangement_fee_prc = data.arrangement_fee_prc;
			this.form.arrangement_fee_amt = data.arrangement_fee_amt;
			this.form.arrangement_sst_prc = data.arrangement_sst_prc;

			if ((this.arg_fee_opt.indexOf(data.arrangement_fee_prc) < 0) && !_gHlp.isEmpty(data.arrangement_fee_prc)) {
				this.arg_fee = 'Specify';
			} else if (!_gHlp.isEmpty(data.arrangement_fee_prc)) {
				this.arg_fee = data.arrangement_fee_prc;
			}
		},
		updateAll() {
			this.is_loading = true;
			if (this.arg_fee != 'Specify') {
				this.form.arrangement_fee_prc = this.arg_fee
			}

			this.updateCase(this.form).then(res => {
				_gNotif.notifySuccess("Case loan detail has been update")
				this.is_loading = false;
			});
		}
	}
}
</script>